import type { LoginInfo } from "@/types/LoginInfo";

export const isSystemUser = (loginInfo: LoginInfo | null | undefined): boolean =>
  loginInfo?.organisation?.organisationType === "SYSTEM";

export const isPartnerUser = (loginInfo: LoginInfo | null | undefined): boolean =>
  loginInfo?.organisation?.organisationType === "PARTNER";

export const isSystemOrPartner = (loginInfo: LoginInfo | null | undefined): boolean =>
  isSystemUser(loginInfo) || isPartnerUser(loginInfo);
